import { render, staticRenderFns } from "./ProjectSingle.vue?vue&type=template&id=4a937697&"
import script from "./ProjectSingle.vue?vue&type=script&lang=js&"
export * from "./ProjectSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports